import photoClient from '~/clients/photoClient';

export default function generateMetaData({ title, applicationNameTitle, description, image, videoURL, staticImage, url, addPlayButtonOnShareImage, faviconImage, oEmbed }) {
    let metaData = { meta: [], link: [] };

    if (oEmbed) {
        metaData.link.push({
            hid: 'oembed',
            rel: 'alternate',
            type: 'application/json+oembed',
            href: 'https://api.beams.fm/oEmbed?url=' + encodeURIComponent(url),
            title: 'oEmbed',
        });
    }

    if (title != null) {
        metaData.title = title;
        metaData.meta.push({
            hid: 'og:title',
            property: 'og:title',
            content: `${title}`,
        });
        metaData.meta.push({
            hid: 'twitter:title',
            property: 'twitter:title',
            content: `${title}`,
        });
    }

    if (applicationNameTitle) {
        metaData.meta.push({
            hid: 'application-name',
            property: 'application-name',
            content: applicationNameTitle,
        });
    }

    if (description != null) {
        metaData.meta.push({
            hid: 'description',
            name: 'description',
            content: description,
        });
        metaData.meta.push({
            hid: 'og:description',
            property: 'og:description',
            content: description,
        });
        metaData.meta.push({
            hid: 'twitter:description',
            property: 'twitter:description',
            content: description,
        });
    }

    if (videoURL != null) {
        metaData.meta.push({
            hid: 'og:video:width',
            property: 'og:video:width',
            content: 720,
        });
        metaData.meta.push({
            hid: 'og:video:height',
            property: 'og:video:height',
            content: 1280,
        });
        metaData.meta.push({
            hid: 'og:video:type',
            property: 'og:video:type',
            content: 'video/mp4',
        });
        metaData.meta.push({
            hid: 'og:video:url',
            property: 'og:video:url',
            content: videoURL,
        });
    }

    if (url != null) {
        metaData.meta.push({
            hid: 'og:url',
            property: 'og:url',
            content: url,
        });
    }

    let finalImage = staticImage;
    let finalTwitterImage = staticImage;

    let defaultImageWidth = 300;
    let defaultImageHeight = 300;

    if (image != null && image.urlTemplate) {
        finalImage = photoClient.getURL({
            template: image.urlTemplate,
            width: defaultImageWidth,
            height: defaultImageHeight,
            playButtonOverlayColor: addPlayButtonOnShareImage ? 'redSmall' : null,
        });

        finalTwitterImage = photoClient.getURL({
            template: image.urlTemplate,
            width: defaultImageHeight,
            height: defaultImageHeight,
            playButtonOverlayColor: addPlayButtonOnShareImage ? 'blue' : null,
        });
    }

    if (finalImage) {
        addImageToMetadata(metaData, {
            image: finalImage,
            twitterImage: finalTwitterImage,
            width: defaultImageWidth,
            height: defaultImageHeight,
        });
    }

    metaData.meta.push({
        hid: 'twitter:card',
        property: 'twitter:card',
        content: 'summary',
    });

    if (faviconImage) {
        metaData.link.push(
            {
                hid: 'favicon-apple-touch',
                rel: 'apple-touch-icon',
                sizes: '180x180',
                href: photoClient.getURL({
                    template: faviconImage.urlTemplate,
                    width: 180,
                    height: 180,
                }),
            },
            {
                hid: 'favicon-icon-32',
                rel: 'icon',
                type: 'image/png',
                sizes: '32x32',
                href: photoClient.getURL({
                    template: faviconImage.urlTemplate,
                    width: 32,
                    height: 32,
                }),
            },
            {
                hid: 'favicon-icon-16',
                rel: 'icon',
                type: 'image/png',
                sizes: '16x16',
                href: photoClient.getURL({
                    template: faviconImage.urlTemplate,
                    width: 16,
                    height: 16,
                }),
            },
        );
    }
    return metaData;
}

function addImageToMetadata(metaData, { image, twitterImage, width, height }) {
    metaData.meta.push({
        hid: 'og:image',
        property: 'og:image',
        itemprop: 'image',
        content: image,
    });

    metaData.meta.push({
        hid: 'og:image:secure_url',
        property: 'og:image:secure_url',
        content: image,
    });

    metaData.meta.push({
        hid: 'og:image:width',
        property: 'og:image:width',
        content: width,
    });

    metaData.meta.push({
        hid: 'og:image:height',
        property: 'og:image:height',
        content: height,
    });

    metaData.meta.push({
        hid: 'twitter:image',
        property: 'twitter:image',
        itemprop: 'image',
        content: twitterImage,
    });
}
